import PropTypes from 'prop-types';

import {ADMIN_LEVELS} from '../state/auth/authSelector';

const levelValues = Object.keys(ADMIN_LEVELS).map((key) => ADMIN_LEVELS[key]);
const adminLevel = PropTypes.oneOf(levelValues);

export default adminLevel;
